
export const MEISTERSCHAFT_BEWERBE = [
    { value: 'f', label: 'Damen', sort: 10, plural: 'Personen', singular: 'Person'},
    { value: 'm', label: 'Herren', sort: 20, plural: 'Personen', singular: 'Person'},
    { value: 'x', label: 'Gemischt', sort: 30, plural: 'Teams', singular: 'Team'},
]

export const BEWERB_MODUS_OPTIONEN = [
    { value: 'tabelle', label: 'Gereiht nach Einzelergebnissen' },
    { value: 'tabelle_ko', label: '1. Runde Quali gereiht nach Einzelergebnissen, danach K.o.-System' },
    { value: 'ko', label: 'K.o.-System' },
]

export const BEWERB_KO_PLATZ_5_BIS_8 = [
    { value: "exAequo", label: "alle Viertelfinalverlierer ex aequo auf Rang 5" },
    { value: "loser", label: "Reihung nach Viertelfinal-Kegel" },
]

export const BEWERB_KO_PLATZ_3_BIS_4 = [
    { value: "exAequo", label: "kein Rang 4, Semifinalverlierer ex aequo auf Rang 3" },
    { value: "loser", label: "Reihung nach Halbfinal-Kegel" },
    { value: "ko", label: "Spiel um Platz 3" },
]

export const LABEL_BEWERB_KO_PLATZ_3_BIS_4 = {
    title: "Finalrunde",
    [0]: "Spiel um Platz 3",
    [1]: "Finale",
}

export const BEWERB_ANZAHL_STARTER = [
    { value: 2, label: "2" },
    { value: 4, label: "4" },
    { value: 8, label: "8" },
    { value: 16, label: "16" },
    { value: 32, label: "32" },
    { value: 64, label: "64" },
    { value: 128, label: "128" },
]

export const RESULT_STATUS = [
    { value: 'finished', label: 'Beendet', sort: 1 },
    { value: 'disq', label: 'Disqualifiziert', sort: 2 },
    { value: 'dns', label: 'Nicht gestartet', sort: 3 },
    { value: 'wo', label: 'w.o.', sort: 1 },
]